(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode(".asset-canvas[data-v-bb99757d]{aspect-ratio:16/9;height:100%;display:flex;justify-content:center;align-items:center;background-color:#000;color:#fff;border-radius:var(--border-radius);font-size:1em;font-weight:700}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
var ie = Object.defineProperty, ue = Object.defineProperties;
var de = Object.getOwnPropertyDescriptors;
var j = Object.getOwnPropertySymbols;
var ce = Object.prototype.hasOwnProperty, pe = Object.prototype.propertyIsEnumerable;
var H = (p, c, d) => c in p ? ie(p, c, { enumerable: !0, configurable: !0, writable: !0, value: d }) : p[c] = d, C = (p, c) => {
  for (var d in c || (c = {}))
    ce.call(c, d) && H(p, d, c[d]);
  if (j)
    for (var d of j(c))
      pe.call(c, d) && H(p, d, c[d]);
  return p;
}, B = (p, c) => ue(p, de(c));
var h = (p, c, d) => new Promise((t, y) => {
  var e = (m) => {
    try {
      g(d.next(m));
    } catch (l) {
      y(l);
    }
  }, L = (m) => {
    try {
      g(d.throw(m));
    } catch (l) {
      y(l);
    }
  }, g = (m) => m.done ? t(m.value) : Promise.resolve(m.value).then(e, L);
  g((d = d.apply(p, c)).next());
});
import { defineComponent as Q, ref as f, computed as me, watch as _, watchEffect as W, onMounted as Z, onUnmounted as ye, defineAsyncComponent as q, createElementBlock as k, createBlock as G, unref as r, openBlock as S, normalizeStyle as x, createVNode as ge, createElementVNode as ve, toDisplayString as fe } from "vue";
import { a as K, c as b, b as $, g as Ie, A as V, P as w } from "./index-BmGD5jiK.js";
import { e as Be, d as Me, s as _e } from "./index-BmGD5jiK.js";
import { L as Ee } from "./VideoAssetPlayer-DMUTcRT-.js";
import { V as Ge } from "./VideoAssetPlayer-DMUTcRT-.js";
import { v as he, u as be } from "./useAssetPlayer-DXalh3Ib.js";
import { _ as Pe } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { _ as Ve } from "./ImageAssetPlayer.vue_vue_type_script_setup_true_lang-CVAAsYNJ.js";
import { _ as Ye, a as je, b as He, c as Ke, d as $e, e as Qe, f as We, g as Ze, h as Xe, i as Je, j as et, k as tt, l as at } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { _ as st, a as nt, b as rt, c as lt } from "./ShieldIcon.vue_vue_type_script_setup_true_lang-DEvS6x_g.js";
import { _ as ut, a as dt, b as ct, c as pt, d as mt, e as yt } from "./VolumeMuteIcon.vue_vue_type_script_setup_true_lang-C85Cvqdw.js";
import { _ as vt, a as ft, b as It, R as Et, c as ht, T as bt } from "./TripleDotIcon-CnE5eu_G.js";
import { i as Rt } from "./setup-CsWQu8N3.js";
import { d as Lt, b as Tt, e as At, c as Ct, a as wt, S as Ot } from "./StreamAttendeeControlBar-W0bWlORx.js";
import { P as Dt, d as Nt, c as kt, b as Ft, R as Bt, a as Mt } from "./RoomChat-B7Zg0eWW.js";
const De = /* @__PURE__ */ Q({
  __name: "FileUpload",
  props: {
    file: { type: File, required: !0 },
    appSource: { type: String, required: !0 },
    entityType: { type: String, required: !0 },
    entityId: { type: String, required: !0 },
    sourceEntityType: { type: String, required: !0 },
    sourceEntityId: { type: String, required: !0 },
    type: {
      type: String,
      required: !0,
      validator: (p) => ["video", "image", "audio"].includes(p)
    },
    token: { type: String },
    onSuccess: { type: Function, default: () => {
    } },
    onError: { type: Function, default: () => {
    } },
    playRaw: { type: Boolean, default: !1 },
    imageProcessorOptions: {
      type: Object
    },
    destinationFolderPath: {
      type: String
    }
  },
  emits: ["progress-update", "status-change"],
  setup(p, { expose: c, emit: d }) {
    const t = {
      READY: "ready",
      NO_FILE: "no_file",
      INITIALIZING: "start_uploading",
      IN_PROGRESS: "uploading",
      FAILED_SIGNED_URL: "error_signed_url",
      PROCESSING: "processing",
      QUEUED: "queued",
      COMPLETED: "completed",
      RETRYING: "error_retry",
      FAILED_PERMANENTLY: "error_non_recoverable",
      FAILED_UPLOAD: "error_upload",
      FAILED_UNKNOWN: "error_unknown"
    }, y = {
      format: "webp",
      quality: 80
    }, e = p, L = d, g = f(!1), m = f(0), l = f(0), i = f(t.READY), v = f(null), T = f(null), A = f(null), P = f(null), R = f(null), E = f(null), M = me(
      () => e.playRaw ? m.value : Math.min(m.value * 0.5 + l.value * 0.5, 100)
    );
    _(M, (a) => {
      L("progress-update", a);
    }), _(i, (a) => {
      L("status-change", a);
    });
    let O = null, o = null;
    W(() => {
      e.file && (i.value = t.READY);
    });
    const n = () => h(this, null, function* () {
      if (!e.file) {
        i.value = t.NO_FILE;
        return;
      }
      g.value = !0, m.value = 0, l.value = 0, i.value = t.READY, yield J(), X(), T.value ? ee() : u();
    }), u = () => {
      i.value = t.FAILED_UPLOAD, g.value = !1, e.onError();
    }, X = () => {
      if (!e.file) return;
      const a = {};
      if (a.name = e.file.name, a.mimeType = e.file.type, e.type === b.video || e.type === b.audio) {
        const s = document.createElement(
          e.type === b.video ? b.video : b.audio
        );
        s.src = URL.createObjectURL(e.file), s.addEventListener("loadedmetadata", () => {
          a.durationInSeconds = s.duration, URL.revokeObjectURL(s.src);
        });
      } else if (e.type === b.image) {
        const s = new Image();
        s.src = URL.createObjectURL(e.file), s.onload = () => {
          a.width = s.width, a.height = s.height, URL.revokeObjectURL(s.src);
        };
      }
      E.value = a;
    }, J = () => h(this, null, function* () {
      try {
        const { signedUrl: a, path: s, bucket: I } = yield $.getUploadSignedUrl({
          source: e.appSource,
          entityId: e.entityId,
          type: `${e.type}s`,
          mimeType: e.file.type
        });
        T.value = a, A.value = s, P.value = I;
      } catch (a) {
        i.value = t.FAILED_SIGNED_URL, e.onError();
      }
    }), ee = () => h(this, null, function* () {
      i.value = t.IN_PROGRESS;
      const a = new XMLHttpRequest();
      R.value = a, a.open("PUT", T.value, !0), a.setRequestHeader("Content-Type", e.file.type), a.upload.addEventListener("progress", (s) => {
        if (s.lengthComputable) {
          const I = s.loaded / s.total * 100;
          m.value = I;
        }
      }), a.onload = () => a.status === 200 ? te() : u(), a.onerror = u, a.send(e.file);
    });
    function te() {
      return h(this, null, function* () {
        var a, s, I, U, D;
        try {
          const N = {
            asset: {
              sourceEntityId: e.sourceEntityId,
              sourceEntityType: e.sourceEntityType,
              entityId: e.entityId,
              entityType: e.entityType
            },
            path: `/${A.value.replace(/^\/+/, "")}`,
            source: e.appSource,
            bucket: Ie().BUCKET_NAME,
            assetType: e.type,
            name: (a = E.value) == null ? void 0 : a.name,
            durationInSeconds: (s = E.value) == null ? void 0 : s.durationInSeconds,
            contentType: (I = E.value) == null ? void 0 : I.mimeType,
            width: (U = E.value) == null ? void 0 : U.width,
            height: (D = E.value) == null ? void 0 : D.height,
            destinationFolderPath: e.destinationFolderPath
          };
          if (e.type === "image") {
            const le = e.imageProcessorOptions && Object.keys(e.imageProcessorOptions).length > 0 ? e.imageProcessorOptions : y;
            Object.assign(N, {
              imageProcessorOptions: le
            });
          }
          const { licenseId: re } = yield $.createAsset(
            N
          );
          v.value = re, e.playRaw ? z() : (ae(), oe());
        } catch (N) {
          i.value = t.FAILED_UNKNOWN, g.value = !1, e.onError();
        }
      });
    }
    const ae = () => {
      v.value && (o = setInterval(() => h(this, null, function* () {
        try {
          const [a, s] = yield Promise.all([
            V.getAsset(v.value),
            V.getProcessingStatus(v.value)
          ]);
          switch (s == null ? void 0 : s.status) {
            case w.ERROR:
              i.value = t.RETRYING;
              break;
            case w.PROCESSING:
              i.value = t.PROCESSING;
              break;
            case w.REMAINING:
              i.value = t.QUEUED;
              break;
            case w.UNCODABLE:
              F(), i.value = t.FAILED_PERMANENTLY, e.onError();
              return;
            case w.COMPLETED:
              i.value = t.COMPLETED;
              break;
          }
          (a != null && a.processedUrl || (s == null ? void 0 : s.status) === w.COMPLETED) && z();
        } catch (a) {
        }
      }), 5e3), setTimeout(() => {
        F(), i.value = t.FAILED_PERMANENTLY, e.onError();
      }, 4 * 60 * 60 * 1e3));
    }, z = () => {
      i.value = t.COMPLETED, l.value = 99.9, setTimeout(
        () => {
          F(), g.value = !1, v.value && e.onSuccess({
            licenseId: v.value,
            uploadedFileBucket: P.value,
            uploadedFilePath: A.value
          });
        },
        e.playRaw ? 0 : 1e3
      );
    }, oe = () => {
      i.value = t.INITIALIZING, l.value = 0;
      let a = 100 - l.value, s = 5 * 60, I = a * 0.5, U = l.value;
      function D() {
        const N = I / s;
        l.value = Math.min(
          l.value + N,
          100
        ), l.value >= U + I && (a = 100 - l.value, s = Math.min(s * 2, 4 * 60 * 60), I = a * 0.5, U = l.value), l.value < 100 && I > 0.1 && (O = setTimeout(D, 1e3));
      }
      D();
    }, se = () => {
      g.value = !1, m.value = 0, l.value = 0, i.value = t.READY, v.value = null, T.value = null, A.value = null, R.value = null, E.value = null;
    }, F = () => {
      o && clearInterval(o), O && clearTimeout(O);
    }, Y = () => {
      F(), se();
    }, ne = () => h(this, null, function* () {
      R.value && (R.value.abort(), R.value = null), v.value && (yield V.delete(v.value)), Y();
    });
    return Z(() => {
      e.token && K(e.token);
    }), _(
      () => e.token,
      (a) => {
        a && K(a);
      }
    ), ye(() => h(this, null, function* () {
      Y();
    })), c({
      initiateUpload: n,
      initiateCancelUpload: ne
    }), () => {
    };
  }
}), Re = { key: 0 }, Se = { key: 1 }, Le = /* @__PURE__ */ Q({
  __name: "AssetPlayer",
  props: {
    licenseId: {},
    sourceInfo: {},
    borderRadius: { default: "0.375rem" },
    width: { default: "100%" },
    token: {},
    playRaw: { type: Boolean, default: !1 },
    completionPercentage: { default: 0 },
    primaryColor: { default: "#ffffff95" },
    controlsBgColor: { default: "#1D2939" },
    menuBgColor: { default: "#ffffff" },
    textColor: { default: "#fff" },
    thumbnail: {},
    preview: { type: Boolean, default: !1 },
    subtitles: { default: () => ({}) },
    format: {},
    height: {},
    gravity: {},
    resize: {},
    quality: {},
    pixelate: {},
    blur: {},
    sharpen: {},
    bgRGBColor: {},
    rotate: {},
    padding: {},
    maxBytes: {},
    dpr: {},
    lazy: { type: Boolean }
  },
  emits: [
    "onPause",
    "onEnded",
    "onPlay",
    "onReady",
    "onError",
    "getVideoTime",
    "onCaptionsEnabled",
    "onCaptionsDisabled",
    "onLanguageChange"
  ],
  setup(p, { expose: c, emit: d }) {
    const t = p;
    he(t);
    const y = d, {
      assetUrls: e,
      loading: L,
      processingStatus: g,
      isAssetLicenseDeleted: m,
      cssVariables: l,
      computedLicenseId: i,
      liveSessionStatus: v,
      getProcessingStatus: T,
      initializePlayer: A
    } = be(t), P = f(null), R = f(!1);
    W(() => {
      var o;
      R.value = (o = P.value) == null ? void 0 : o.enableThumbnails;
    }), Z(() => h(this, null, function* () {
      yield A();
    })), c({
      generateThumbnail: () => {
        var o;
        return (o = P.value) == null ? void 0 : o.generateThumbnail();
      },
      enableThumbnails: R,
      toggleCaptions: (o) => {
        var n;
        return (n = P.value) == null ? void 0 : n.toggleCaptions(o);
      },
      setLanguage: (o) => {
        var n;
        return (n = P.value) == null ? void 0 : n.setLanguage(o);
      }
    });
    const E = q(() => import("./VideoPlayer-Cd2n1_--.js")), M = q(() => import("./ImageAssetPlayer.vue_vue_type_script_setup_true_lang-CVAAsYNJ.js").then((o) => o.I)), O = q(
      () => import("./ThumbnailPlayer-DufjIljp.js")
    );
    return (o, n) => r(L) ? (S(), k("div", {
      key: 0,
      class: "asset-canvas",
      style: x(B(C({}, r(l)), { width: t.width, height: t.height }))
    }, [
      ge(Ee)
    ], 4)) : r(v) && r(v).type !== "recording-ready" ? (S(), k("div", {
      key: 1,
      class: "asset-canvas",
      style: x(B(C({}, r(l)), { width: t.width }))
    }, [
      ve("p", null, fe(r(v).message), 1)
    ], 4)) : r(e).assetType === r(b).video && !t.preview ? (S(), G(r(E), {
      key: 2,
      ref_key: "videoPlayerRef",
      ref: P,
      "license-id": r(i),
      width: t.width,
      "play-raw": t.playRaw,
      "completion-percentage": t.completionPercentage,
      "border-radius": t.borderRadius,
      "primary-color": t.primaryColor,
      "controls-bg-color": t.controlsBgColor,
      "menu-bg-color": t.menuBgColor,
      "text-color": t.textColor,
      source: C(C({}, r(e)), r(g)),
      "get-processing-status": r(T),
      thumbnail: t.thumbnail,
      subtitles: t.subtitles,
      onOnPause: n[0] || (n[0] = (u) => y("onPause", u)),
      onOnEnded: n[1] || (n[1] = (u) => y("onEnded", u)),
      onOnPlay: n[2] || (n[2] = (u) => y("onPlay", u)),
      onOnReady: n[3] || (n[3] = (u) => y("onReady", u)),
      onOnError: n[4] || (n[4] = (u) => y("onError", u)),
      onGetVideoTime: n[5] || (n[5] = (u) => y("getVideoTime", u)),
      onOnCaptionsEnabled: n[6] || (n[6] = (u) => y("onCaptionsEnabled", u)),
      onOnCaptionsDisabled: n[7] || (n[7] = (u) => y("onCaptionsDisabled", u)),
      onOnLanguageChange: n[8] || (n[8] = (u) => y("onLanguageChange", u))
    }, null, 8, ["license-id", "width", "play-raw", "completion-percentage", "border-radius", "primary-color", "controls-bg-color", "menu-bg-color", "text-color", "source", "get-processing-status", "thumbnail", "subtitles"])) : r(g).assetType === r(b).video && t.preview ? (S(), G(r(O), {
      key: 3,
      "license-id": r(i),
      width: t.width,
      source: r(e)
    }, null, 8, ["license-id", "width", "source"])) : r(g).assetType === r(b).image ? (S(), G(r(M), {
      key: 4,
      "license-id": r(i),
      "source-info": o.sourceInfo,
      "border-radius": o.borderRadius,
      format: o.format,
      width: o.width,
      height: o.height,
      resize: o.resize,
      dpr: o.dpr,
      gravity: o.gravity,
      quality: o.quality,
      pixelate: o.pixelate,
      blur: o.blur,
      sharpen: o.sharpen,
      "bg-r-g-b-color": o.bgRGBColor,
      rotate: o.rotate,
      padding: o.padding,
      "max-bytes": o.maxBytes,
      lazy: o.lazy
    }, null, 8, ["license-id", "source-info", "border-radius", "format", "width", "height", "resize", "dpr", "gravity", "quality", "pixelate", "blur", "sharpen", "bg-r-g-b-color", "rotate", "padding", "max-bytes", "lazy"])) : (S(), k("div", {
      key: 5,
      class: "asset-canvas",
      style: x(B(C({}, r(l)), { width: t.width }))
    }, [
      r(m) ? (S(), k("p", Se, " The media could not be loaded, try reloading the page. If the problem continues, please contact support. ")) : (S(), k("p", Re, " The media content is no longer available, as it has been deleted. "))
    ], 4));
  }
}), Ne = /* @__PURE__ */ Pe(Le, [["__scopeId", "data-v-bb99757d"]]);
export {
  Ye as ArrowCircleIcon,
  je as ArrowDropdownIcon,
  Ne as AssetPlayer,
  He as AttachFileIcon,
  Ke as AudioLevelIcon,
  $e as CameraFlipIcon,
  Qe as CameraIcon,
  We as ChatIcon,
  st as DisconnectIcon,
  Ze as EmojiIcon,
  ut as EyeIcon,
  De as FileUpload,
  dt as FullScreenIcon,
  vt as GroupUserIcon,
  Ve as ImagePlayer,
  ft as LayoutIcon,
  nt as LeaveIcon,
  Xe as MicrophoneIcon,
  rt as ParticipantIcon,
  Dt as ParticipantsList,
  ct as PauseIcon,
  It as PinIcon,
  pt as PlayIcon,
  Et as RaiseHandIcon,
  ht as ReactionIcon,
  Nt as ReactionPicker,
  kt as RoomChat,
  Ft as RoomControlBar,
  Bt as RoomProvider,
  Mt as RoomView,
  Je as ScreenShareIcon,
  et as SendIcon,
  tt as SettingsIcon,
  lt as ShieldIcon,
  at as SpeakerIcon,
  Lt as StreamAttendeeControlBar,
  Tt as StreamAttendeePlayer,
  At as StreamChat,
  Ct as StreamHostControlBar,
  wt as StreamHostPlayer,
  Ot as StreamProvider,
  bt as TripleDotIcon,
  Ge as VideoPlayer,
  mt as VolumeIcon,
  yt as VolumeMuteIcon,
  Be as deleteAssetLicense,
  Me as downloadAsset,
  Rt as initAssetsDrmClient,
  _e as setEnvironment
};
